/**
 * Validator for ReturnWildlife action.
 *
 * Rules (§6.4, §11.1, §14):
 *   1. stateVersion matches.
 *   2. Phase is "placeWildlife".
 *
 * Per §6.4: "ReturnWildlife — always legal in placeWildlife phase, even if a
 * legal placement exists."
 *
 * The spec says ReturnWildlife is always valid in the placeWildlife phase.
 * The spec note about "if a legal placement exists → ERR_LEGAL_PLACEMENT_EXISTS"
 * in the Phase 2B task description was a clarification note about what NOT to
 * enforce — the spec explicitly says "always legal". No legal-placement check
 * is performed here.
 */

import type { ReturnWildlifeAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { GameState } from "../types/game-state";
import { commonGuards, VALID } from "./common-guards";

export const validateReturnWildlife = (
  state: GameState,
  action: ReturnWildlifeAction,
): ValidationResult => {
  const guard = commonGuards(state, action.stateVersion, "placeWildlife");
  if (guard !== null) {
    return guard;
  }

  return VALID;
};
